import React, { useState, useEffect } from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col, Label, Input, Button, InputGroup, InputGroupText } from 'reactstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { requestApi } from '../../../request-api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Triangle } from 'react-loader-spinner';
import { ElectricalServicesTwoTone } from '@mui/icons-material';


function CreateReport() {
    let [calendarValue, setCalenderValue] = useState(new Date());
    let [showCalender, setShowCalender] = useState(false)
    let [selectedDate, setSelectedDate] = useState("")
    let navigate = useNavigate()
    const [startDate, setStartDate] = useState(new Date());

    const initialFormValues = { realname: "", email: "", number: "" }

    let [formValues, setFormValues] = useState(initialFormValues)
    let [formErrors, setFormErrors] = useState({})
    let [isSubmit, setIsSubmit] = useState(false)
    let [company, setCompany] = useState([])
    let [selectedCompany, setSelectedCompany] = useState('')
    let [selectedBranch, setSelectedBranch] = useState('')
    let [selectedReport, setSelectedReport] = useState('')
    let [selectedCompliancer, setSelectedCompliancer] = useState('')
    let [companyName, setCompanyName] = useState([])
    let [branch, setBranch] = useState([])
    let [report, setReport] = useState([])
    let [compliancer, setCompliancer] = useState([])
    let [allCompliancer, setAllCompliancer] = useState([])
    let [branchData,setBranchData] = useState([])
    let [approver, setApprover] = useState([])
    let [currentApprover, setCurrentApprover] = useState("")
    let [currentCompliancer, setCurrentCompliancer] = useState("")
    let [approverData, setApproverData] = useState([])
      let [loading, setLoading] = useState(false);
       const successToast = (message) =>
         toast.success(message, {
           position: 'bottom-right',
         });

       const errorToast = (error) =>
         toast.error(error, {
           position: 'bottom-right',
         });
    // form field onchange
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }
    useEffect(()=>{
       
            getAllData()
       
    },[])

    const getAllData = () =>{
         requestApi('/auditor/company/getCompanyByUserId',{
            method:'get'
        }).then((data)=>{
            console.log("20",data)
            let company = []
            data.data.map((comp)=>{
                company.push(comp.company_name)
            })
            setCompany(company)
        })
        requestApi('/auditor/getComplianceofficer',{
            method:'get'
        }).then((data)=>{
            let complianceOfficer = []
            setAllCompliancer(data.data)
            data.data.map((comp)=>{
                complianceOfficer.push(comp.name)
            })
            setCompliancer(complianceOfficer)
        })
        requestApi('/auditor/approver/getAllApprover',{
            method:'get'
        }).then((data)=>{
          setApproverData(data.data)
            console.log("---AYAN--------------------->",data.data)
            let approver = []
            data.data.map((app)=>{
                approver.push(app.name)
            })
            setApprover(approver)
        })
    }

    const getBranch = (e) =>{
        e.preventDefault()
        setCompanyName(e.target.value)
        // setCompany([e.target.value]);
        getReport(e)
        console.log("----------------------------------------",e.target.value)
        requestApi('/auditor/branch/getBranchByCompany',{
            method:'post',
            body:JSON.stringify({
                company_name:e.target.value
            })
        }).then((data)=>{
            console.log("20",data)
            setBranchData(data.data)
            let branchdata = []
            data.data.map((comp)=>{
              branchdata.push(comp.branch_id)
            })
            setBranch(branchdata)
          
        }).catch((error)=>{
            console.log(error)
        })
    }

    const getReport = (e) =>{
        e.preventDefault()
        
        requestApi('/auditor/template/getAllTemplate',{
            method:'post',
            body:JSON.stringify({
                company_name:e.target.value
            })
        }).then((data)=>{
            console.log("20",data)
            let report = []
            data.data.map((comp)=>{
                report.push(comp.template_id)
            })
            setReport(report)
        }).catch((error)=>{
            console.log(error)
        })
    }

    //form submit
    
    const validateBanner = async (e) => {
      e.preventDefault();
      setIsSubmit(true);
      const validate = await formValidation()
      setFormErrors(validate);
      console.log("validate",validate)
      if (Object.keys(validate).length == 0) {
        submitData(e);
      }
    };
    //form validation
    const formValidation = () => {
        console.log(startDate)
        const errors = {}
       console.log(company,branch,report,approver,compliancer)
        if (selectedCompany == '' || selectedCompany == 'empty') {
            errors.company = "Company is required" 
        }
        if (selectedBranch == "" || selectedBranch == 'empty' ) {
            errors.branch = "Branch is required"
        }
        if (selectedReport == "" || selectedReport == 'empty' ) {
            errors.report = "Report is required"
        }
        if (currentApprover == '') {
          errors.approver = "Approver is required,Kindly Select branches while making approver"
      }
      if (currentCompliancer == "" || currentCompliancer == 'empty') {
        errors.compliancer = "Compliancer is required,Kindly Select branches while making Compliancer"
    }

        return errors;
    }

    useEffect(() => {
        setSelectedDate(`${calendarValue.getDate()}/${calendarValue.getMonth() + 1}/${calendarValue.getFullYear()}`)
        const company_name = formValidation.getCompanyName;
        setFormValues({
            ...formValues,
            companyname: company_name,
        })
    }, [calendarValue])

    const submitData = (e) =>{
        e.preventDefault()
        setLoading(true)
        console.log("All data >>>",companyName,branch,compliancer,approver,report)
        requestApi('/auditor/createReport',{
            method:'post',
            body:JSON.stringify({
                company_name:selectedCompany,
                branch_id:selectedBranch,
                template_id:selectedReport,
                approver:currentApprover,
                compliance_officer_name:selectedCompliancer
            })
        }).then((data)=>{
          console.log(data)
          setLoading(false)
            if(data.statusCode === 200){
              successToast("Report successfully created")
              navigate(`${directUrl}auditor/reports`)
            }
            
        }).catch((error)=>{
          setLoading(false)
            errorToast(error.message)
            console.log("HEllooo",error)
        })
    }

    const approverSelect = (e)=>{
      setSelectedBranch(e.target.value)
      let id = branchData.find(branchs=> {return e.target.value == branchs.branch_id }).approver_id
      console.log("approver name:",id,"djhfsd")
      if(id != null)
      {
        let appr = approverData.find(app => app.id== id).name
        setCurrentApprover(appr)
        setApprover([appr])
      }
      else{
        errorToast("Approver is not assigned")
      }
     
    }
const compliancerSelect = (e) =>{
      let cid = branchData.find(branchs=> {return e.target.value == branchs.branch_id }).compliance_officer_id
      console.log("first",cid)
      if(cid != '')
      {
        let comp = allCompliancer.find(app => app.id== cid).name
        setCurrentCompliancer(comp)
        setSelectedCompliancer(comp)
      }else{
        errorToast("Compliance Officer is not assigned")
      }
}
   

    return (
      <section className="lyt-section">
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : null}
        <Container fluid className="typ-container">
          <Breadcrumb className="bs-breadcrumb mt-0">
            <BreadcrumbItem>
              <NavLink to={`${directUrl}auditor/reports`}>Report</NavLink>
            </BreadcrumbItem>
            <BreadcrumbItem active>Create Report</BreadcrumbItem>
          </Breadcrumb>
          <div className="bs-card px-0">
            <div className="padding-area">
              <form className="bs-form">
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h2 className="bs-heading mb-big">Create Report</h2>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="ex1" className="mr-sm-2 cstm-label">
                      Company Name<span style={{color:'red'}}>*</span>
                    </Label>
                    <Input
                      className="typ-select mob-margin"
                      onChange={(e) => {
                        setCurrentApprover("")
                        setCurrentCompliancer("")
                        setSelectedCompany(e.target.value)
                        getBranch(e);
                      }}
                      value={selectedCompany}
                      type="select"
                      name="selectofficer1"
                      id="ex1"
                    >
                      <option value="empty">Select Company</option>
                      {company.map((comp) => {
                        return (
                          <option key={comp} value={comp}>
                            {comp}
                          </option>
                        );
                      })}
                    </Input>
                    <p className="error-message">{formErrors.company}</p>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="ex2" className="mr-sm-2 cstm-label">
                      Branch name<span style={{color:'red'}}>*</span>
                    </Label>
                    <Input
                      className="typ-select mob-margin"
                      onChange={(e) => {
                        e.preventDefault()
                       
                        approverSelect(e)
                        compliancerSelect(e)
                      }}
                      value={selectedBranch}
                      type="select"
                      name="selectofficer2"
                      id="ex2"
                    >
                      <option value="empty">Select Branch name</option>
                      {branch.map((brh) => {
                        return (
                          <option key={brh} value={brh}>
                            {brh}
                          </option>
                        );
                      })}
                    </Input>
                    <p className="error-message">{formErrors.branch}</p>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="ex3" className="mr-sm-2 cstm-label">
                      Report Templates<span style={{color:'red'}}>*</span>
                    </Label>
                    <Input
                      className="typ-select mob-margin"
                      type="select"
                      onChange={(e) => {
                        setSelectedReport(e.target.value)
                      }}
                      value={selectedReport}
                      name="selectofficer3"
                      id="ex3"
                    >
                      <option value="0">Select Report Templates</option>
                      {report.map((rep) => {
                        return (
                          <option key={rep} value={rep}>
                            {rep}
                          </option>
                        );
                      })}
                    </Input>
                    <p className="error-message">{formErrors.report}</p>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="ex4" className="mr-sm-2 cstm-label">
                      Approver<span style={{color:'red'}}>*</span> 
                    </Label>
                    <Input
                      className="typ-text mob-margin"
                      type="text"
                      disabled
                      value={currentApprover}
                      name="selectofficer4"
                      id="ex4"
                    >
                      {/* <option value="0">Select Approver</option>
                      {approver.map((compli) => {
                        return (
                          <option key={compli} value={compli}>
                            {compli}
                          </option>
                        );
                      })} */}
                    </Input>
                    <p className="error-message">{formErrors.approver}</p>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="ex5" className="mr-sm-2 cstm-label">
                    Compliancer Officer*
                    </Label>
                    <Input
                      className="typ-select mob-margin"
                      type="text"
                      disabled
                      name="selectofficer5"
                      // onChange={(e) => {
                      //   setSelectedCompliancer(e.target.value)
                      // }}
                      value={currentCompliancer}
                      id="ex5"
                    >
                      {/* <option value="0">Select Compliance Officer</option>
                      {compliancer.map((compli) => {
                        return (
                          <option key={compli} value={compli}>
                            {compli}
                          </option>
                        );
                      })} */}
                    </Input>
                    <p className="error-message">{formErrors.compliancer}</p>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <button
                      type="button"
                      className="bs-btn btn-submit"
                      onClick={(e)=>{validateBanner(e)}}
                    >
                      SUBMIT
                    </button>
                  </Col>
                </Row>
              </form>
            </div>
          </div>
          <ToastContainer />
        </Container>
      </section>
    );
}

export default CreateReport